import React from "react";
import "../../Styles/commonfooter.css";

const PrivacyPolicy = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="main-app-contianer">
      <div className="pp-banner-section">
        <div className="width-wrapper">
          <div className="wrap-1" data-aos="zoom-in-down">
            <h1>Privacy Policy</h1>
            <p>
              At Ann, we are committed to protecting your privacy. This Privacy
              Policy explains how we collect, use, and safeguard your personal
              data when you use our website and services.
            </p>
          </div>
        </div>
      </div>

      <div className="box-1">
        <div className="width-wrapper">
          <div className="box-wrap " data-aos="zoom-in-down">
            <h2>1. Information We Collect</h2>
            <p>
              We collect personal data such as name, contact details, resume
              content, job preferences, and <br />
              system usage data to provide and improve our recruitment platform.
              We may also collect technical data like IP addresses, device type,
              and cookies.
            </p>
          </div>
        </div>
      </div>

      <div className="wrap-card">
        <div className="width-wrapper">
          <div className="row">
            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>2. How We Use Your Information</h2>
              <p>Your data helps us:</p>
              <ul className="i">
                <li>Match job seekers with suitable job opportunities.</li>
                <li>Provide automated shortlisting and interview services.</li>
                <li>Improve and personalize our services.</li>
                <li>
                  Communicate with you about your account or service updates.
                </li>
              </ul>
            </div>
            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>3. Sharing of Information</h2>
              <p>We only share your information with:</p>
              <ul className="i">
                <li>
                  Employers and recruiters as part of the recruitment process.
                </li>
                <li>
                  Service providers assisting in our operations (e.g., hosting,
                  analytics).
                </li>
                <li>When required by law or to protect legal rights.</li>
              </ul>
            </div>
            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>4. Data Security</h2>
              <p>
                We use industry-standard measures to protect your data against
                unauthorized access, alteration or loss. Access to data is
                restricted to authorized personnel only.
              </p>
            </div>
            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>5. Your Rights</h2>
              <p>
                You may access, update, or request deletion of your personal
                data. If you reside in certain jurisdictions, you also enjoy
                wider or restrict processing under applicable privacy laws.
              </p>
            </div>
            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>6. Cookies and Tracking</h2>
              <p>
                We use cookies to enhance user experience and gather usage data.
                You can control cookie preferences through your browser
                settings.
              </p>
            </div>
            <div className="card" data-aos="fade-left" data-aos-delay="200">
              <h2>7. Changes to this Policy</h2>
              <p>
                We may update this policy from time to time. Changes will be
                posted on this page with the updated effective date.
              </p>
            </div>
            <div className="card" data-aos="fade-right" data-aos-delay="200">
              <h2>8. Contact Us</h2>
              <p>
                For questions or concerns about this policy or your data,
                contact us at: <br />
                <strong>Email:</strong> privacy@ann.ai
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default PrivacyPolicy;
